import api from '../axios';

export async function listarDiscipulados(params) {
  const res = await api.get('/discipulados/', { params });
  return res.data;
}

export async function getDiscipulado(id) {
  const res = await api.get(`/discipulados/${id}`);
  return res.data;
}

export async function criarDiscipulado(data) {
  const res = await api.post('/discipulados/', data);
  return res.data;
}

export async function atualizarDiscipulado(id, data) {
  const res = await api.put(`/discipulados/${id}`, data);
  return res.data;
}

export async function deletarDiscipulado(id) {
  const res = await api.delete(`/discipulados/${id}`);
  return res.data;
}

export async function meusDiscipulados() {
  const res = await api.get('/discipulados/meus-discipulados');
  return res.data;
}

export async function meuDiscipulador() {
  const res = await api.get('/discipulados/meu-discipulador');
  return res.data;
}

export async function membrosSemDiscipulador() {
  const res = await api.get('/discipulados/sem-discipulador');
  return res.data;
}

export async function vincularCurso(discipuladoId, cursoId) {
  const res = await api.post(`/discipulados/${discipuladoId}/vincular-curso/${cursoId}`);
  return res.data;
}
